import React from 'react';
import './TaskCard.css';
import { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import { Task } from './App';

interface TaskCardProps {
    task: Task;
    dragHandleProps?: DraggableProvidedDragHandleProps | null;
    onEdit?: (task: Task) => void; // new prop for editing
}

const TaskCard: React.FC<TaskCardProps> = ({ task, dragHandleProps, onEdit }) => {
    const dueDate = new Date(task.dueDate);
    dueDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const isOverdue = dueDate < today;
    const isDueToday = dueDate.getTime() === today.getTime();

    const cardClass = `task-card ${isOverdue ? 'overdue' : isDueToday ? 'due-today' : ''}`;

    return (
        <div className={cardClass} onClick={() => onEdit && onEdit(task)}>
            <div
                className="drag-handle"
                {...(dragHandleProps || {})}
                onClick={(e) => e.stopPropagation()} // prevent click propagation from drag handle
            >
                <span className="hamburger-icon">☰</span>
            </div>
            <div className="task-content">
                <h3 className="task-title">{task.title}</h3>
                <div className="task-info">
                    <p>Estimated: {task.estimatedLength} hr{task.estimatedLength !== 1 && 's'}</p>
                    <p>Due: {new Date(task.dueDate).toLocaleDateString()}</p>
                </div>
            </div>
        </div>
    );
};

export default TaskCard;